<template>
    <div class="showPdf">
        <iframe :src="pSrc" width="100%" height="100%"></iframe>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pSrc: ''
        }
    },
    methods: {
        loadPDF() {
            //pdf文件地址  测试可用
            // let baseurl = 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf'
            // let baseurl = 'http://x.mashang8.com/StockInfo/Attachment/202207/xSJGBxWn60yI6oPZ-000_C556_C735_.pdf'
            let baseurl = this.$route['query']['HtmlPath'];
            // console.log(baseurl);
            this.pSrc = '../../static/pdfjs/web/viewer.html?file=' + encodeURIComponent(baseurl)
        }
    },
    mounted() {
        this.loadPDF()
    }
}
</script>

<style>
.showPdf {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleDetail.vue